import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from "rxjs";
import { AppConfig } from 'src/app.config';
import { SysPesquisaDinamica } from 'src/app/model/system/sysPesquisaDinamica';
import { GenericService } from '../generics/generic.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
    providedIn: 'root'
})
export class SysPesquisaDinamicaService extends GenericService<SysPesquisaDinamica>{

    constructor(http: HttpClient) {
        super(http);
        super.initResource("syspesquisadinamica")
    }

    findGrupos(idCompany: number, grupo: string): Observable<any[]> {
        const url = `${this.url}/nomesPorGrupo/${idCompany}/${grupo}`;
        //console.log(`Chamando URL para grupos: ${url}`);
        return this.http.get<any[]>(url).pipe(tap(data => console.log('Dados retornados para grupos:', data))
        );
    }

    findConsultaDinamica(idCompany: number, nomeConsulta: string): Observable<any> {
        const url = `${this.url}/executarConsulta/${idCompany}`;
        //console.log(`Chamando URL para consulta dinâmica: ${url}, com nomeConsulta: ${nomeConsulta}`);
        return this.http.post<any>(url, { nome: nomeConsulta }).pipe(tap(data => console.log('Dados retornados para consulta dinâmica:', data))
        );
    }

    findRelatoriosByGrupo( idEmpresa: number, grupo: string ): Observable<{ id: number; nome: string; relPaisagem: string; espacLinhas: number; impLinhas: string; 
        impDetalhe: string; impQuebraPag: string; geraGrafico: string; tipoGrafico: string; colValores: string; colTitulo: string;}[]> {
        const url = `${this.url}/relatoriosPorGrupo/${idEmpresa}`;
        const body = { grupo };
        return this.http.post<{ id: number; nome: string; relPaisagem: string; espacLinhas: number; impLinhas: string; impDetalhe: string; 
            impQuebraPag: string; geraGrafico: string; tipoGrafico: string; colValores: string; colTitulo: string;}[]>(url, body, httpOptions).pipe(
            tap(data => console.log('Relatórios retornados:', data))
        );
    }

    getTraducoes(idRelatorio: string, idioma: string): Observable<{ [key: string]: string }> {
        const url = `${this.url}/traducoes/${idRelatorio}`;
        const body = { idioma };
        return this.http.post<{ [key: string]: string }>(url, body, httpOptions).pipe(
            tap((data) => console.log('Traduções retornadas:', data))
        );
    }    

    findDistinctGrupos(idCompany: number): Observable<string[]> {
        const url = `${this.url}/grupos/${idCompany}`;
        return this.http.get<string[]>(url).pipe(tap(data => console.log('Grupos distintos retornados:', data))
        );
    }

    extractParametros(nomeRelatorio: string): Observable<string[]> {
        const url = `${this.url}/extrairParametros`;
        const body = { grupo: nomeRelatorio };
        console.log("Enviando ao backend:", body); // Log do corpo da requisição
        return this.http.post<string[]>(url, body, httpOptions).pipe(tap(data => console.log("Parâmetros extraídos:", data))
        );
    }
    

}
